import { humanReadableDuration, mySqlToLocal } from "@helpers"

const lastImportDuration = (date1, date2 = null) => (date1 ? humanReadableDuration(mySqlToLocal(date1)) + " ago" : null)

export default lastImportDuration
